<template>
  <v-tabs background-color="teal" centered dark>
    <!-- <v-tabs-slider></v-tabs-slider> -->

    <v-tab
      v-for="(items, option) in options"
      :key="option"
      @click="setOption(option)"
      >{{ option }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  props: {
    options: Object,
    setOption: Function,
  },
};
</script>
